
const digest = '59a2c4109e2d9e9c851fbed7581866602c584dd8323c10c50717dae3b7657aa3';
const classes = {"wrapper":"_wrapper_1j32k_1","iconWrapper":"_iconWrapper_1j32k_7","bold":"_bold_1j32k_13","controls":"_controls_1j32k_16"};
const css = `._wrapper_1j32k_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 15px;
}
._wrapper_1j32k_1 ._iconWrapper_1j32k_7 {
  display: flex;
  flex-direction: row;
  gap: 7px;
  align-items: center;
}
._wrapper_1j32k_1 ._bold_1j32k_13 {
  font-weight: 500;
}
._wrapper_1j32k_1 ._controls_1j32k_16 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  